__turbopack_context__.v({
  "container": "CollectionsLayout-module-scss-module__DlsRZq__container",
  "content": "CollectionsLayout-module-scss-module__DlsRZq__content",
  "drawerButton": "CollectionsLayout-module-scss-module__DlsRZq__drawerButton",
  "drawerHeader": "CollectionsLayout-module-scss-module__DlsRZq__drawerHeader",
  "filterContainer": "CollectionsLayout-module-scss-module__DlsRZq__filterContainer",
  "sidebar": "CollectionsLayout-module-scss-module__DlsRZq__sidebar",
  "sidebarToggle": "CollectionsLayout-module-scss-module__DlsRZq__sidebarToggle",
});
